module.exports = "pegasus/assets/blocks/column-6-theme6.png";